import { isDevelopmentEnvironment } from "./estada-config";
import WatchableValue from "./models/WatchableValue";

//
// DONT Chnage Values !!!
// are stored in the UserRights in the database
//
export enum enumUiMode {
  user = 0,
  expert = 1,
  productAdmin = 2,
  admin = 3,
  developer = 4,
}

//////////////////////////////////////////////////////////////////////////////////////////////

let _uiMode: enumUiMode = parseInt(localStorage.getItem("uiMode") || `${enumUiMode.user}`);

export const uiModeWatcher = new WatchableValue<enumUiMode>(getUiMode());

export function getUiMode(): enumUiMode {
  return _uiMode;
}

export function setUiMode_XX(newValue: enumUiMode) {
  _uiMode = newValue;
  uiModeWatcher.value = newValue;
  localStorage.setItem("uiMode", newValue.toString());
}

//////////////////////////////////////////////////////////////////////////////////////////////

let _maxUiMode: enumUiMode = enumUiMode.user;
export function getMaxUiMode(): enumUiMode {
  return _maxUiMode;
}

export function setMaxUiMode(newValue: enumUiMode) {
  _maxUiMode = newValue;
}

////////////////////////////////////////////////////////////////////////////////////

let _isBetaVersion: boolean | undefined;
export function isBetaVersion(): boolean {
  if (isDevelopmentEnvironment()) {
    return true;
  }

  if (_isBetaVersion === undefined) {
    _isBetaVersion = window.location.href.toLocaleLowerCase().includes("beta");
  }

  return _isBetaVersion;
}

export function isUiModeUser(): boolean {
  return !isUiModeExpert();
}

export function isUiModeExpert(): boolean {
  return getUiMode() >= enumUiMode.expert;
}

export function isUiModeProductAdmin(): boolean {
  return getUiMode() >= enumUiMode.productAdmin;
}

export function isUiModeAdmin(): boolean {
  return getUiMode() >= enumUiMode.admin;
}

export function isUiModeDeveloper(): boolean {
  if (isDevelopmentEnvironment()) {
    return getUiMode() >= enumUiMode.developer;
  }
  return false;
}
